import React, { FC, ChangeEventHandler } from "react";
import styled from "styled-components";
import { inputStyle } from "./styles";

interface Props {
  id: string;
  value: string;
  name: string;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: any;
  error?: boolean;
  minHeight?: number;
  disabled?: boolean;
}
const TextareaInput: FC<Props> = ({ ...props }) => {
  return <Textarea {...props} />;
};

const Textarea = styled.textarea<Props>`
  ${({ error }) => inputStyle({ error })};
  padding: 10px 15px;
  padding-top: 0.7em;
  padding-bottom: 0.7em;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : "150px")};
  max-height: 300px;
  resize: vertical;

  &:disabled {
    background: #e3e3e3;
  }
`;

export default TextareaInput;
